export enum VerificationStatusEnum {
    IS_PRIMARY,
    IN_PROCESS,
    COMPLETED,
    PROCESSED_BY_CERT,
    PASSED_TO_ANOTHER_TEAM,
    RESOLVED_BY_ANOTHER_TEAM,
}
